module.exports = __webpack_public_path__ + "img/mlh.f594cf64.png";